import { useSelector, useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { modalSelector } from 'Store/modules/app/selectors';
import { hideModalAction } from 'Store/modules/app/actions';
import { useTranslation } from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import { CloseIcon } from 'Components/icons';
import * as Styled from './styles';

const WarningModal = (): JSX.Element => {
  const modal = useSelector(modalSelector);
  const { t } = useTranslation(locizeNS.MODALS);
  const dispatch = useDispatch();
  const { options } = modal;

  const { title, content, link } = modal;
  const { acceptText, cancelText, notCancel, noClose, ternary, color, cancelAction } = options;

  const closeModal = (): void => {
    cancelAction?.();
    dispatch(hideModalAction());
  };
  const handleSubmit = (): void => {
    if (typeof options.action !== 'undefined') {
      options.action();
    }
    closeModal();
  };

  return (
    <Styled.ModalContainer>
      <Styled.ModalContent>
        {!noClose && (
          <Styled.CloseButton onClick={closeModal}>
            <CloseIcon />
          </Styled.CloseButton>
        )}
        <Text type="fds_text_semibold_L" align="center" mb="fds_size_16" color="dark_500">
          <Trans i18nKey={title} ns="modals" />
        </Text>
        <Text
          mb="fds_size_24"
          color={color ?? 'red_1'}
          align="center"
          type="fds_paragraph_medium_S"
        >
          {t(content)}
        </Text>
        {link && (
          <FlexContainer justify="flex-end">
            <Buttons.Tiny
              mode="success"
              label={t('common:KnowMore')}
              onClick={() => history.push(link)}
            />
          </FlexContainer>
        )}
        <FlexContainer
          justify={notCancel ? 'flex-end' : 'space-between'}
          style={{ marginTop: 'auto' }}
        >
          {!notCancel && !ternary ? (
            <Buttons.Classic
              className="submit-button"
              size="m"
              mode="success_light"
              label={t(cancelText ?? 'Cancel')}
              onClick={closeModal}
            />
          ) : (
            <Buttons.Classic
              className="submit-button"
              label={t(cancelText ?? 'Cancel')}
              size="m"
              mode="success_light"
              onClick={closeModal}
            />
          )}
          <Buttons.Classic
            className="submit-button"
            size="m"
            onClick={handleSubmit}
            mode="error"
            testID="warningModalSubmit"
            label={t(acceptText ?? 'Accept')}
          />
        </FlexContainer>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default WarningModal;
